import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Branch } from '../../interfaces/total-reports/branch.interface';

@Injectable({
    providedIn: 'root',
})
export class BranchService {
    constructor(private readonly http: HttpClient) {}

    getBranch(): Observable<Branch[]> {
        return this.http.get<Branch[]>(environment.url + `/api/Branch`);
    }

    getBranchZambiaNorthmead(): Observable<Branch[]> {
        return this.http.get<Branch[]>(environment.url + `/api/Branch/Zambia/northmead`);
    }

    getBranchZambiaMobile(): Observable<Branch[]> {
        return this.http.get<Branch[]>(
            environment.url + `/api/Branch/Zambia/mobile`,
        );
    }
}
